import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
  secondary: {
    backgroundColor: theme.palette.purple.main,
  },
  success: {
    backgroundColor: theme.palette.green.main,
  },
  warning: {
    backgroundColor: theme.palette.red.main,
  },
  error: {
    backgroundColor: theme.palette.red.main,
  },
  blue: {
    backgroundColor: theme.palette.blue.main,
  },
  purple: {
    backgroundColor: theme.palette.purple.main,
  },
  green: {
    backgroundColor: theme.palette.green.main,
  },
  orange: {
    backgroundColor: theme.palette.orange.main,
  },
  red: {
    backgroundColor: theme.palette.red.main,
  },
  black: {
    backgroundColor: theme.palette.black.main,
  },
  grey: {
    backgroundColor: theme.palette.grey.main,
  },
}));

export default styles;
